import { useEffect, useState } from 'react'
import { RenderClient } from 'src/components/RenderClient'

import type { AlliboProps } from './allibo-props'
import './allibo.scss'

function Allibo(AlliboProps: AlliboProps) {
  const [showPage, setshowPage] = useState(0)

  useEffect(() => {
    const linkAllibo = AlliboProps.allibopage[showPage].linkallibo
    const script = document.createElement('script')

    script.type = 'text/javascript'
    script.id = 'AlliboList'
    script.src = linkAllibo
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [showPage, AlliboProps])

  return (
    <>
      <div className="allibo-title">
        <div className="allibo-item">
          {AlliboProps.allibopage.map((value, index) => (
            <button
              key={index}
              className={`allibo-button-title ${
                index === showPage ? 'allibo-active' : ''
              }`}
              onClick={() => setshowPage(index)}
            >
              {value.title}
            </button>
          ))}
        </div>
      </div>

      <div id="AlliboList" className="allibo-list">
        <div>
          <a
            href="https://www.allibo.com?src=joblist"
            rel="follow noreferrer"
            target="_blank"
            aria-hidden="true"
            className="AHRP_subj"
          >
            <img
              src="https://joblink.allibo.com/ats2/www_lib/load.gif"
              alt="Allibo"
            />
          </a>
        </div>
      </div>
    </>
  )
}

function AlliboWrapper(AlliboProps: AlliboProps) {
  return (
    <RenderClient>
      {' '}
      <Allibo {...AlliboProps} />{' '}
    </RenderClient>
  )
}

export default AlliboWrapper
